import { render, staticRenderFns } from "./Unsealer.vue?vue&type=template&id=53463d9a&"
import script from "./Unsealer.vue?vue&type=script&lang=js&"
export * from "./Unsealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports